import { Api } from './Api'

const couponsPathTo = {
  list: () => {
    return Api.request({
      url: '/coupons.json',
      method: 'get',
    })
  },
  get: (id) => {
    return Api.request({
      url: `/coupons/${id}.json`,
      method: 'get',
    })
  },
  save: (data) => {
    return Api.request({
      url: '/coupons.json',
      method: 'post',
      data: { coupon: data }
    })
  },
  update: (id, data) => {
    return Api.request({
      url: `/coupons/${id}.json`,
      method: 'put',
      data: { coupon: data }
    })
  },
  publicShow: (code) => {
    return Api.request({
      url: `/public/coupons/${encodeURIComponent(code)}.json`,
      method: 'get',
    })
  },
  redeem: (code) => {
    return Api.request({
      url: `/coupons/${encodeURIComponent(code)}/redeem.json`,
      method: 'post',
    })
  },
  current: () => {
    return Api.request({
      url: '/coupons/current.json',
      method: 'get',
    })
  },
}

export default couponsPathTo
